/* Trapprofielshop – thema-gedrag. Werkt in Shopify (Ajax Cart API) en in de lokale preview (window.TV_PREVIEW). */
(function () {
  'use strict';
  var PREVIEW = window.TV_PREVIEW || null;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var money = function (cents) {
    return '€ ' + (cents / 100).toFixed(2).replace('.', ',');
  };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); };
  var t = window.TV_STRINGS || {};

  /* ---------- Winkelwagen-adapter ---------- */
  var Cart = PREVIEW ? PREVIEW.cart : {
    get: function () { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); },
    add: function (id, qty) {
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: qty }] }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message); return j; }); })
        .then(function () { return Cart.get(); });
    },
    change: function (key, qty) {
      return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) }).then(function (r) { return r.json(); });
    },
    note: function (note) {
      return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note }) });
    },
    checkoutUrl: '/checkout'
  };

  var Search = PREVIEW ? PREVIEW.search : function (q) {
    return fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,variants.sku,tag')
      .then(function (r) { return r.json(); })
      .then(function (j) {
        return j.resources.results.products.map(function (p) {
          return { title: p.title, url: p.url, image: p.image, price: Math.round(parseFloat(p.price) * 100), type: p.type };
        });
      });
  };

  function toast(msg) {
    var el = $('#toast');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { el.hidden = true; }, 2600);
  }

  /* ---------- Drawers ---------- */
  var lastFocus = null;
  function openDrawer(id) {
    var d = document.getElementById(id);
    if (!d) return;
    lastFocus = document.activeElement;
    d.hidden = false;
    document.body.style.overflow = 'hidden';
    var f = d.querySelector('button, a, input');
    if (f) f.focus();
  }
  function closeDrawer(d) {
    d.hidden = true;
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-open]');
    if (o) { e.preventDefault(); openDrawer(o.getAttribute('data-open')); if (o.getAttribute('data-open') === 'cart-drawer') renderCart(); return; }
    var c = e.target.closest('[data-close]');
    if (c) { e.preventDefault(); closeDrawer(c.closest('.drawer')); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $$('.drawer:not([hidden])').forEach(closeDrawer);
    var sp = $('#search-panel');
    if (sp && !sp.hidden) toggleSearch(false);
  });

  /* ---------- Zoeken ---------- */
  function toggleSearch(show) {
    var sp = $('#search-panel');
    if (!sp) return;
    sp.hidden = !show;
    var btn = $('[data-search-toggle]');
    if (btn) btn.setAttribute('aria-expanded', show ? 'true' : 'false');
    if (show) $('input', sp).focus();
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-search-toggle]');
    if (b) { e.preventDefault(); toggleSearch($('#search-panel').hidden); }
  });
  var searchInput = $('#search-panel input[name=q]');
  if (searchInput) {
    var out = $('#predictive');
    var timer;
    searchInput.addEventListener('input', function () {
      var q = searchInput.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { out.innerHTML = ''; return; }
      timer = setTimeout(function () {
        Search(q).then(function (items) {
          if (searchInput.value.trim() !== q) return;
          out.innerHTML = items.length ? items.map(function (p) {
            return '<a href="' + esc(p.url) + '" role="option">' + (p.image ? '<img src="' + esc(p.image) + '" alt="" width="52" height="52" loading="lazy">' : '') +
              '<span><b>' + esc(p.title) + '</b><small>' + esc(p.type || '') + ' · ' + (t.from || 'vanaf') + ' ' + money(p.price) + '</small></span></a>';
          }).join('') : '<p class="empty">' + (t.no_results || 'Geen producten gevonden') + ' “' + esc(q) + '”.</p>';
        });
      }, 120);
    });
    searchInput.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      var links = $$('a', out);
      if (!links.length) return;
      e.preventDefault();
      var i = links.indexOf(document.activeElement);
      (links[e.key === 'ArrowDown' ? Math.min(i + 1, links.length - 1) : Math.max(i - 1, 0)]).focus();
    });
  }

  /* ---------- Winkelwagen weergave ---------- */
  function lineHtml(it) {
    var orig = it.original_line_price != null ? it.original_line_price : it.final_line_price;
    return '<div class="cart-line" data-key="' + esc(it.key) + '">' +
      '<a href="' + esc(it.url) + '"><img src="' + esc(it.image || '') + '" alt="" width="72" height="72" loading="lazy"></a>' +
      '<div><h3><a href="' + esc(it.url) + '">' + esc(it.product_title) + '</a></h3>' +
      (it.variant_title ? '<small>' + esc(it.variant_title) + '</small>' : '') +
      (it.sku ? '<small>Art.nr. ' + esc(it.sku) + '</small>' : '') +
      '<div class="qty"><button type="button" data-line-qty="-1" aria-label="Minder">−</button>' +
      '<input type="number" min="0" value="' + it.quantity + '" aria-label="Aantal" data-line-input>' +
      '<button type="button" data-line-qty="1" aria-label="Meer">+</button></div>' +
      '<button type="button" class="cart-line__remove" data-line-remove>Verwijderen</button></div>' +
      '<div class="cart-line__price">' + (orig > it.final_line_price ? '<s style="color:#888;font-weight:500">' + money(orig) + '</s><br>' : '') + money(it.final_line_price) + '</div></div>';
  }
  function totalsHtml(cart) {
    var excl = Math.round(cart.total_price / 1.21);
    var disc = cart.total_discount || 0;
    var free = (window.TV_SETTINGS && window.TV_SETTINGS.freeShippingCents) || 0;
    var meter = free ? (cart.total_price >= free ? '<div class="ship-meter">✓ ' + (t.free_shipping_reached || 'Je bestelling wordt gratis verzonden') + '</div>' :
      '<div class="ship-meter">Nog ' + money(free - cart.total_price) + ' tot gratis verzending</div>') : '';
    return meter + '<div class="cart-totals">' +
      (disc ? '<div><span>Staffelkorting</span><span>−' + money(disc) + '</span></div>' : '') +
      '<div class="grand"><span>Totaal</span><span>' + money(cart.total_price) + '</span></div>' +
      '<div class="muted"><span>Waarvan btw (21%)</span><span>' + money(cart.total_price - excl) + '</span></div>' +
      '<div class="muted"><span>Totaal excl. btw</span><span>' + money(excl) + '</span></div>' +
      '<div class="muted"><span>Verzendkosten</span><span>berekend bij afrekenen</span></div></div>';
  }
  function updateCount(cart) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.setAttribute('data-count', cart.item_count); });
  }
  function renderCart(cart) {
    var p = cart ? Promise.resolve(cart) : Cart.get();
    return p.then(function (c) {
      updateCount(c);
      $$('[data-cart-items]').forEach(function (el) {
        el.innerHTML = c.items.length ? c.items.map(lineHtml).join('') :
          '<div class="cart-empty"><p><b>' + (t.cart_empty || 'Je winkelwagen is leeg') + '</b></p><a class="btn btn--accent" href="' + (PREVIEW ? PREVIEW.url('collections/trapneuzen') : '/collections/trapneuzen') + '">Bekijk trapneuzen</a></div>';
      });
      $$('[data-cart-totals]').forEach(function (el) { el.innerHTML = c.items.length ? totalsHtml(c) : ''; });
      $$('[data-cart-checkout]').forEach(function (el) { el.hidden = !c.items.length; });
      return c;
    });
  }
  document.addEventListener('click', function (e) {
    var line = e.target.closest('.cart-line');
    if (!line) return;
    var key = line.getAttribute('data-key');
    var input = $('[data-line-input]', line);
    var q = null;
    if (e.target.closest('[data-line-qty]')) q = Math.max(0, parseInt(input.value, 10) + parseInt(e.target.closest('[data-line-qty]').getAttribute('data-line-qty'), 10));
    if (e.target.closest('[data-line-remove]')) q = 0;
    if (q === null) return;
    line.style.opacity = '.5';
    Cart.change(key, q).then(renderCart);
  });
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-line-input]')) return;
    var line = e.target.closest('.cart-line');
    Cart.change(line.getAttribute('data-key'), Math.max(0, parseInt(e.target.value, 10) || 0)).then(renderCart);
  });
  var noteEl = $('[data-cart-note]');
  if (noteEl) noteEl.addEventListener('change', function () { Cart.note(noteEl.value); });
  $$('[data-cart-checkout]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      if (PREVIEW) { e.preventDefault(); toast('Preview: afrekenen gebeurt straks in de beveiligde Shopify-checkout.'); }
    });
  });
  renderCart();

  /* ---------- Productpagina ---------- */
  var pj = $('#product-json');
  if (pj) {
    var data = JSON.parse(pj.textContent);
    var form = $('#product-form');
    var idInput = $('input[name=id]', form);
    var qtyInput = $('input[name=quantity]', form);
    var addBtn = $('[data-add]', form);
    var current = data.variants.filter(function (v) { return String(v.id) === idInput.value; })[0] || data.variants[0];

    // Staffels kunnen beperkt zijn tot bepaalde varianten (veld "variants" in het staffel-metaveld).
    function tiersFor(v) {
      return (data.tiers || []).filter(function (t) { return !t.variants || t.variants.indexOf(v.option1) > -1; });
    }
    function activeTier(q) {
      var tiers = tiersFor(current);
      for (var i = tiers.length - 1; i >= 0; i--) if (q >= tiers[i].min) return tiers[i];
      return null;
    }
    function paint() {
      var q = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      var tier = activeTier(q);
      var unitCents = tier ? Math.round(parseFloat(tier.incl) * 100) : current.price;
      $('[data-price]').textContent = money(unitCents);
      $('[data-price-excl]').textContent = money(Math.round(unitCents / 1.21));
      $('[data-sku]').textContent = current.sku || '—';
      var unitEl = $('[data-unit]');
      if (unitEl && current.unit) unitEl.textContent = current.unit;
      var st = $('[data-stock]');
      st.textContent = current.available ? (t.in_stock || 'Leverbaar – op voorraad binnen 1 werkdag na betaling verzonden') : (t.sold_out || 'Tijdelijk uitverkocht');
      st.classList.toggle('is-out', !current.available);
      addBtn.disabled = !current.available;
      addBtn.querySelector('span').textContent = current.available ? (t.add || 'In winkelwagen') : (t.sold_out_short || 'Uitverkocht');
      $$('.tiers tr[data-min]').forEach(function (tr) { tr.classList.toggle('is-active', !!tier && String(tier.min) === tr.getAttribute('data-min')); });
      var tiersBox = $('.tiers');
      if (tiersBox) tiersBox.hidden = tiersFor(current).length === 0;
      var sb = $('[data-sticky-price]');
      if (sb) sb.textContent = money(unitCents);
    }
    $$('input[name=option1]', form).forEach(function (r) {
      r.addEventListener('change', function () {
        current = data.variants.filter(function (v) { return v.option1 === r.value; })[0];
        idInput.value = current.id;
        var out = $('[data-option-value]', form);
        if (out) out.textContent = r.value;
        if (current.image) showImage(current.image);
        if (!PREVIEW && history.replaceState) history.replaceState(null, '', location.pathname + '?variant=' + current.id);
        paint();
      });
    });
    $$('[data-qty]', form).forEach(function (b) {
      b.addEventListener('click', function () {
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + parseInt(b.getAttribute('data-qty'), 10));
        paint();
      });
    });
    qtyInput.addEventListener('input', paint);
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      addBtn.disabled = true;
      Cart.add(parseInt(idInput.value, 10), Math.max(1, parseInt(qtyInput.value, 10) || 1))
        .then(function (c) { renderCart(c); openDrawer('cart-drawer'); })
        .catch(function (err) { toast(err.message || 'Toevoegen mislukt'); })
        .then(function () { addBtn.disabled = !current.available; });
    });

    var main = $('.gallery__main img');
    function showImage(src) {
      main.src = src;
      $$('.gallery__thumbs button').forEach(function (b) { b.setAttribute('aria-current', b.getAttribute('data-src') === src ? 'true' : 'false'); });
    }
    $$('.gallery__thumbs button').forEach(function (b) {
      b.addEventListener('click', function () { showImage(b.getAttribute('data-src')); main.alt = b.querySelector('img').alt; });
    });

    // Trapcalculator: treden x breedte -> aantal profielen van vaste lengte, met staffelprijs.
    var calc = $('[data-calc]');
    if (calc) {
      var L = parseFloat(calc.getAttribute('data-length')) || 115;
      var stepsIn = $('[data-calc-steps]', calc), widthIn = $('[data-calc-width]', calc), result = $('[data-calc-result]', calc);
      var need = 0;
      var num = function (el) { return parseFloat(String(el.value).replace(',', '.')); };
      var calcPaint = function () {
        var s = Math.floor(num(stepsIn)), w = num(widthIn);
        if (!(s > 0) || !(w > 0)) { result.hidden = true; need = 0; return; }
        var per = Math.ceil(w / L);
        need = s * per;
        var tier = activeTier(need);
        var unit = tier ? Math.round(parseFloat(tier.incl) * 100) : current.price;
        var rest = Math.round((per * L - w) * 10) / 10;
        result.innerHTML =
          '<p class="calc__need"><b>' + need + ' trapneuzen</b> van ' + L + ' cm' +
          (per > 1 ? ' <span>(' + per + ' per trede, aan elkaar gelegd)</span>' : '') + '</p>' +
          '<p>' + money(unit) + ' per stuk' + (tier && tier.min > 1 ? ' (staffelprijs)' : '') + ' · totaal <b>' + money(unit * need) + '</b> incl. btw</p>' +
          (rest > 0 ? '<p class="calc__rest">Per trede snijdt u ' + String(rest).replace('.', ',') + ' cm af.</p>' : '') +
          '<button type="button" class="btn btn--accent" data-calc-add' + (current.available ? '' : ' disabled') + '>' +
          (current.available ? need + ' stuks in winkelwagen' : (t.sold_out_short || 'Uitverkocht')) + '</button>';
        result.hidden = false;
      };
      stepsIn.addEventListener('input', calcPaint);
      widthIn.addEventListener('input', calcPaint);
      form.addEventListener('change', calcPaint);
      result.addEventListener('click', function (e) {
        if (!e.target.closest('[data-calc-add]') || !need) return;
        qtyInput.value = need;
        paint();
        form.requestSubmit ? form.requestSubmit() : addBtn.click();
      });
    }

    var sticky = $('.sticky-buy');
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { sticky.classList.toggle('is-visible', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(addBtn);
      $('[data-sticky-add]').addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : addBtn.click(); });
    }
    paint();
  }

  /* ---------- Collectiefilters ---------- */
  var ff = $('#filters-form');
  if (ff) {
    var grid = $('[data-product-grid]');
    var sortSel = $('[data-sort]');
    var applyPreview = function () {
      var groups = {};
      $$('input[type=checkbox]:checked', ff).forEach(function (c) {
        var k = c.getAttribute('data-key');
        (groups[k] = groups[k] || []).push(c.value);
      });
      var shown = 0;
      $$('.card', grid).forEach(function (card) {
        var ok = Object.keys(groups).every(function (k) {
          var vals = (card.getAttribute('data-f-' + k) || '').split('|');
          return groups[k].some(function (v) { return vals.indexOf(v) > -1; });
        });
        card.hidden = !ok;
        if (ok) shown++;
      });
      var s = sortSel ? sortSel.value : '';
      var cards = $$('.card', grid);
      if (s) {
        cards.sort(function (a, b) {
          if (s === 'price-ascending') return a.dataset.price - b.dataset.price;
          if (s === 'price-descending') return b.dataset.price - a.dataset.price;
          if (s === 'title-ascending') return a.dataset.title.localeCompare(b.dataset.title, 'nl');
          return a.dataset.pos - b.dataset.pos;
        }).forEach(function (c) { grid.appendChild(c); });
      }
      $('[data-result-count]').textContent = shown;
      $('[data-no-results]').hidden = shown > 0;
      var chips = $('[data-active-filters]');
      chips.innerHTML = $$('input[type=checkbox]:checked', ff).map(function (c) {
        return '<button type="button" class="chip" data-uncheck="' + esc(c.id) + '">' + esc(c.value) + ' ✕</button>';
      }).join('');
    };
    ff.addEventListener('change', function () {
      if (PREVIEW) applyPreview(); else ff.submit();
    });
    if (sortSel) sortSel.addEventListener('change', function () {
      if (PREVIEW) { applyPreview(); return; }
      var u = new URL(location.href);
      u.searchParams.set('sort_by', sortSel.value);
      location.href = u.toString();
    });
    document.addEventListener('click', function (e) {
      var u = e.target.closest('[data-uncheck]');
      if (!u) return;
      document.getElementById(u.getAttribute('data-uncheck')).checked = false;
      ff.dispatchEvent(new Event('change'));
    });
    var ft = $('[data-filters-toggle]');
    if (ft) ft.addEventListener('click', function () {
      var w = $('.filters-wrap');
      w.hidden = !w.hidden;
      ft.setAttribute('aria-expanded', String(!w.hidden));
    });
    if (PREVIEW) applyPreview();
  }

  /* ---------- Contactformulier (preview) ---------- */
  if (PREVIEW) {
    $$('form[data-contact]').forEach(function (f) {
      f.addEventListener('submit', function (e) {
        e.preventDefault();
        f.innerHTML = '<p class="form-msg">Preview: in Shopify wordt dit bericht naar het e-mailadres van de winkel gestuurd.</p>';
      });
    });
  }
})();
